// eslint-disable-next-line
define(function () {
  return {
    imagePath: '',
    enums: {
      alertEntity: {
        none: 0,
        import: 1,
        migration: 4,
        budgetOpportunity: 5,
        keywordOpportunity: 6,
        disapproved: 7,
        maintenance: 11,
        accountSuspended: 12,
        introBingAdsforioS: 20,
        incompatibleBrowsers: 22,
        adBlockWarning: 26,
        productsLimitation: 1000000,
      },
      alertType: {
        none: 0,
        info: 1,
        warn: 2,
        error: 3,
      },
      accountStatus: {
        none: 0,
        creditHold: 18,
        lockedForUpdate: 28,
        pendingPaymentInstrument: 29,
        draft: 30,
        active: 31,
        inActive: 32,
        deleted: 33,
        proposed: 34,
        pendingCreditCheck: 35,
        noHold: 36,
        soldToOnly: 37,
        creditWarning: 38,
        hold: 39,
        locked: 40,
        noLock: 41,
        userPaused: 42,
        suspended: 43,
        writeOff: 223,
        paused: 234,
        taxOnHold: 253,
        userHold: 254,
      },
      accountInactiveReason: {
        notSet: 0,
        pausedDueToSystemIssue: 1,
        pausedZeroBalance: 2,
        pausedNoValidiO: 3,
        processing: 4,
        pendingPaymentMethod: 5,
        pendingNewCustomer: 6,
        inactive: 7,
        hold: 8,
        deleted: 9,
      },
    },
  };
});
